module.exports = __webpack_public_path__ + "static/iccws-black-964c337ea4618dd621c34c54cd90e6c1.png";